import { render, staticRenderFns } from "./Page013.vue?vue&type=template&id=94ca8adc&scoped=true&"
import script from "./Page013.vue?vue&type=script&lang=js&"
export * from "./Page013.vue?vue&type=script&lang=js&"
import style0 from "./Page013.vue?vue&type=style&index=0&id=94ca8adc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ca8adc",
  null
  
)

export default component.exports